import classNames from "classnames";
import { observer } from "mobx-react";
import React from "react";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { ITagGroup } from "../../../../../models/tagGroups/TagGroupStore";
import { ITag } from "../../../../../models/tags/TagsStore";
import { TagsList } from "../../../tags/tagName/tagsList";
import sharedStyles from "../styles.css";
import styles from "./adviserTagsSummary.css";

interface Props {
  tags: ITag[];
  tagGroups: ITagGroup[];
  placeholder?: string;
}

export const AdviserTagsSummary = observer(
  ({
    tags,
    tagGroups,
    placeholder = intl.formatMessage("settings.advisers.noSkillsAddMore")
  }: Props) => {
    const renderTags = () => {
      if (tags.length > 0 || tagGroups.length > 0) {
        return (
          <div className={styles["tags-container"]}>
            <TagsList tags={tags} tagGroups={tagGroups} />
          </div>
        );
      }

      return <p className={sharedStyles["missing-info"]}>{placeholder}</p>;
    };

    return (
      <div className={classNames(sharedStyles.container, styles.container)}>
        <p
          className={classNames(
            sharedStyles["font-description"],
            sharedStyles["description-margin"]
          )}
        >
          {intl.formatMessage("settings.advisers.form.tags")}
        </p>
        {renderTags()}
      </div>
    );
  }
);
